<opac-dialog [title]="title() | translate" [open]="isOpen()" (closed)="closeDialog()">
  <p>{{ description() | translate }}</p>

  <div class="content" *ngFor="let item of content()">
    <span class="icon">
      <opac-icon [icon]="item.iconLigature"></opac-icon>
    </span>
    <div class="item">
      <h3 *ngIf="item.title">{{ item.title | translate }}</h3>
      <p>{{ item.description | translate }}</p>
    </div>
  </div>

  <opac-button slot="actions" *ngIf="showActions()" (click)="closeDialog()">
    {{'general.accept' | translate}}
  </opac-button>
</opac-dialog>
